var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16527 0.667969C7.52127 0.669969 8.41194 0.678635 9.3586 0.716635L9.6946 0.731302C10.6473 0.775969 11.5993 0.853302 12.0719 0.984635C12.7019 1.16197 13.1966 1.67797 13.3639 2.33264C13.6306 3.37264 13.6639 5.40064 13.6679 5.89197L13.6686 5.9933V6.1093C13.6639 6.60064 13.6306 8.6293 13.3639 9.66864C13.1946 10.3253 12.6993 10.842 12.0719 11.0166C11.5993 11.148 10.6473 11.2253 9.6946 11.27L9.3586 11.2853C8.41194 11.3226 7.52127 11.332 7.16527 11.3333L7.0086 11.334H6.8386C6.08527 11.3293 2.9346 11.2953 1.93194 11.0166C1.3026 10.8393 0.807271 10.3233 0.639938 9.66864C0.373271 8.62864 0.339938 6.60064 0.335938 6.1093V5.89197C0.339938 5.40064 0.373271 3.37197 0.639938 2.33264C0.809271 1.67597 1.3046 1.1593 1.9326 0.985302C2.9346 0.705969 6.08594 0.671969 6.83927 0.667969H7.16527ZM5.6686 3.66797V8.33464L9.6686 6.0013L5.6686 3.66797Z",
    fill: "#00465C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3a2ac81238b28f0961f0eb0a3285b748.svg";
export { ForwardRef as ReactComponent };